export const validation = {
  title: { required: true },
  headingMaxChar: 20,
  paragraphMaxChar: 90,
  headerSocials: {
    min: 0,
    max: 7
  }
}